import { memo } from 'react';

import './NoResults.scss';

const NoResults = () => (
  <div className="search-all__content__results__block__body__no-results">
    <svg
        className="search-all__content__results__block__body__no-results__svg"
        height="32" 
        viewBox="0 0 40 32"
        width="40" 
    >
      <path d="M35.149 4.707l-.008-.01c-.08-.123-.196-.216-.337-.253L20.714.71c.01-.144-8.207 1.657-10.218 2.091L4.298 4.444c-.14.037-.257.129-.336.25l-.01.013L.1 10.957c-.106.172-.129.39-.06.584.07.194.22.34.405.388l3.409.904v14.519c0 .293.184.548.445.617l15.115 4.007c.046.012.092.018.138.018.046 0 .091-.008.136-.02l15.117-4.005c.26-.069.444-.324.444-.617v-5.734c0-.351-.26-.636-.581-.636-.321 0-.582.285-.582.636v5.234L20.132 30.55v-19.4l2.789 4.524c.11.178.292.28.482.28.046 0 .092-.006.137-.018l10.545-2.795v5.934c0 .351.26.636.582.636.32 0 .581-.285.581-.636v-6.242l3.409-.904c.185-.049.336-.194.404-.388.07-.194.047-.412-.06-.585L35.15 4.707zM20.505 1.963L32.2 5.062l-12.067 3.2V6.297c0-.35-.26-.635-.582-.635-.32 0-.58.284-.58.635v1.963L6.901 5.06l13.603-3.098zM5.015 26.852V13.14l4.457 1.181c.046.012.092.018.137.018.263 0 .5-.195.565-.486.076-.341-.116-.684-.428-.767l-5.178-1.373-.02-.005-3.018-.8 3.16-5.125 13.911 3.688-3.16 5.125-3.34-.886c-.311-.082-.625.127-.701.468-.076.342.116.685.428.768l3.733.99c.045.011.091.017.137.017.19 0 .372-.102.482-.28l2.79-4.525v19.402l-13.954-3.7zm29.536-15.143l-.014.004-10.878 2.884-3.16-5.125L34.41 5.784l3.16 5.125-3.019.8z"/>
    </svg>
    <div className="search-all__content__results__block__body__no-results__background"/>
    <p className="search-all__content__results__block__body__no-results__text">
      Sorry, nothing found!
    </p>
  </div>
)

export default memo(NoResults);